import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaVideo,
  FaStar,
  FaEye,
  FaRocket,
  FaMobileAlt,
  FaUsers,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const BestVideoProductionServicesInDIFC = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="Best Video Production Services in DIFC" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Elevate Your Brand</Subheading>}
        heading={
          <Heading>
            Best <span tw="text-primary-500">Video Production Services</span> in
            DIFC
          </Heading>
        }
        description={
          <Description>
            At MilaajBrandset, we offer the best video production services in
            **DIFC**, delivering visually stunning and impactful videos that
            elevate your brand. From corporate videos to promotional content, we
            bring your vision to life.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1492691527719-9d1e07e534b4?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
          "https://images.unsplash.com/photo-1601506521937-0121a7fc2a6b?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
          "https://images.unsplash.com/photo-1578302758063-0ef3e048ca89?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Create Your Video"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="Expert Video Production in DIFC"
        description="We craft videos with creativity and professionalism at the core."
        cards={[
          {
            icon: <FaVideo color="#ff5464" size={40} />,
            title: "Cinematic Quality",
            description: "High-definition visuals that captivate audiences.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Award-Winning Team",
            description: "Experienced professionals trusted in DIFC.",
          },
          {
            icon: <FaEye color="#ff5464" size={40} />,
            title: "Brand-Focused Storytelling",
            description: "Videos that align with your brand vision.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Fast Turnaround",
            description: "Timely delivery without compromising quality.",
          },
          {
            icon: <FaMobileAlt color="#ff5464" size={40} />,
            title: "Optimized for All Platforms",
            description: "Videos tailored for web, mobile, and social media.",
          },
          {
            icon: <FaUsers color="#ff5464" size={40} />,
            title: "Client-Centric Approach",
            description: "Collaborative process for perfect results.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Work</Subheading>}
        heading="Our Video Production Process"
        description={
          <Description>
            We create professional videos with a streamlined approach:
            <ul tw="mt-4 list-disc pl-6">
              <li>Consultation: Understand your goals and vision.</li>
              <li>Scripting: Craft compelling narratives.</li>
              <li>Filming: Use state-of-the-art equipment.</li>
              <li>Editing: Refine visuals and audio for impact.</li>
              <li>Delivery: Provide polished videos ready to shine.</li>
              <li>Support: Offer ongoing assistance and updates.</li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1582152629442-4a864303fb96?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
          "https://images.unsplash.com/photo-1509281373149-e957c6296406?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
          "https://images.unsplash.com/photo-1570727624862-3008fe67a6be?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Success Stories</Subheading>}
        heading="Video Production Wins in DIFC"
        description="Our videos have transformed brands in DIFC."
        cards={[
          {
            icon: <FaVideo color="#ff5464" size={40} />,
            title: "Viral Campaign",
            description: "Boosted engagement with a viral promotional video.",
          },
          {
            icon: <FaEye color="#ff5464" size={40} />,
            title: "Brand Visibility",
            description: "Increased reach for a DIFC corporate client.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Client Satisfaction",
            description: "95% approval from DIFC businesses.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready for Professional Videos?</Subheading>}
        heading="Best Video Production in DIFC"
        description={
          <Description>
            Partner with MilaajBrandset for the best video production services
            in DIFC. Create compelling, high-quality videos that reflect your
            brand—contact us today!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1524658751880-16a600520565?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
          "https://images.unsplash.com/photo-1605130284535-11dd9eedc58a?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
          "https://images.unsplash.com/photo-1485846234645-a62644f84728?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
